module.exports = __webpack_public_path__ + "03_long_gray.9e4800f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_long_gray.png
// module id = X1TK
// module chunks = 0